// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".help-container {\n  display: inline-flex;\n  align-items: center;\n}\n.help-container::before {\n  content: '';\n  display: inline-block;\n  background: #d9d9d9;\n  width: 1px;\n  margin: 0 16px;\n  height: 24px;\n}\n.help-container .question {\n  font-size: 24px;\n  color: #8c8c8c;\n  opacity: 0.6;\n}\n", ""]);
// Exports
module.exports = exports;
